import NewsletterTwentyThreeContainer from "./containers/NewsletterTwentyThreeContainer";
export default NewsletterTwentyThreeContainer;
